import React from "react";

import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import Icon from "../../../../components/Icon";
import Typography from "../../../../components/Text";

import css from "./InfoBanner.module.scss";

interface InfoBannerProps {
	type: "success" | "error" | "warning" | "info";
	message: string;
	icon?: IconDefinition;
}

const InfoBanner = ({ type, message, icon }: InfoBannerProps) => {
	return (
		<div className={`${css.infoBanner} ${css[`type-${type}`]}`}>
			{icon && (
				<div className={css.icon}>
					<Icon icon={icon} size="sm" />
				</div>
			)}
			<Typography size="caption" weight="semi-bold">
				{message}
			</Typography>
		</div>
	);
};

export default InfoBanner;
